import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

/**
 * The machinery of the desktop article page, kept out of the page component:
 * the scroll container the analytics and the section rail read, and ⌘J, which
 * opens Chat with paper on this article from anywhere on the page. It is bound
 * in the capture phase so it wins over the desktop shell's own ⌘J (the quick
 * composer), which has no paper to talk about.
 */
export function useArticlePageShell(slug: string): {
  scrollRef: React.RefObject<HTMLDivElement>;
} {
  const history = useHistory();
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      const mod = e.metaKey || e.ctrlKey;
      if (mod && e.key === "j") {
        e.preventDefault();
        e.stopPropagation();
        history.push(`/post/${slug}/chat`);
      }
    }
    window.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => {
      window.removeEventListener("keydown", handleKeyDown, { capture: true });
    };
  }, [history, slug]);

  return { scrollRef };
}
